import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { DynamicDialogRef } from 'primeng/api';
import { DynamicDialogConfig } from 'primeng/api';
import { MembershipService } from '../../services/membership.service';
import { NewmemberService } from '../../services/newmember.service';
import domtoimage from 'dom-to-image';
import { MessageService } from 'primeng/api';
import { DialogService } from 'primeng/api';

@Component({
  selector: 'app-ecard',
  templateUrl: './ecard.component.html',
  styleUrls: ['./ecard.component.css'],
  providers: [DialogService]
})
export class EcardComponent implements OnInit {
  cardHolderInfo: any = {};
  businessName: string;
  startDate: string;
  documentId: string;
  photo: string;
  notFound: boolean = false;
  ustatus: boolean = false;
  imgValid: boolean = true;
  uploadedFiles: any = {};
  ecardValue: string;
  nextRenewDate:string;
  otpFlag:boolean = false;

  constructor(private messageService: MessageService,
              public memberService: MembershipService,
              public ref: DynamicDialogRef,
              public config: DynamicDialogConfig,
              public nms: NewmemberService) { }

  ngOnInit() {
    this.cardHolderInfo = this.config.data.cardHolderInfo;
    this.businessName = this.config.data.businessName;
    this.startDate = this.config.data.startDate;
    this.nextRenewDate = this.config.data.nextRenewDate;
    this.otpFlag = this.config.data.otpFlag;
    if(this.cardHolderInfo.cardHolderDocuments != null) {
      for (let documentInfo of this.cardHolderInfo.cardHolderDocuments) {      
        if (documentInfo.documentType == "PHOTO") {
          this.documentId = documentInfo.documentId;
        }
      }
    }
    this.nms.setDefault(this.cardHolderInfo.membershipNbr, this.cardHolderInfo.maMembershipId, null);
    if (this.documentId != null) {
      this.nms.fetchFiles(this.documentId).subscribe((res: any) => {
        if (res.code === 'SUCCESS') {

          for (let list of res.response.filesList) {
            let temp: any = {};
            temp.vaultId = list.vaultId;
            this.photo = list.file;
          }
        }
      });
    } else {
      this.notFound = true;
    }
    if (this.startDate == null) {
      this.startDate = '2019-29-01';
    }
    this.ecardValue =  "11734" + this.cardHolderInfo.cardHolderNbr + "0" + 
   ('00000000'+ this.cardHolderInfo.membershipNbr).slice(-9);
  }

  ustatusUpdate(event) {
    this.ustatus = event;
  }

  updateUploadstatus(event) {
    this.documentId = event.documentId;
    this.nms.savePhoto(this.cardHolderInfo.cardHolderNbr,this.documentId).subscribe((res: any) => {
      if (res.code=="SUCCESS") {
        this.nms.fetchFiles(this.documentId).subscribe((res: any) => {
          if (res.code === 'SUCCESS') {
            this.notFound = false;
            for (let list of res.response.filesList) {
              let temp: any = {};
              temp.vaultId = list.vaultId;
              this.photo = list.file;
            }

          }
        });
      }
    });
  }

  sendCard(cardHolderNbr) {
    if(this.cardHolderInfo.status == "P") {
      this.nms.updateCardStatus(cardHolderNbr).subscribe((res: any) => {
        if (res.code=="SUCCESS") {
          this.nms.sendCard(cardHolderNbr).subscribe((res: any) => {
            if (res.code=="SUCCESS") {
              this.ref.close();
              setTimeout(() => {
                this.messageService.add({ severity: 'success', summary: 'Membership', detail: 'E-Card download link is successfully sent' });
            }, 1000);
              
            }
          });
        } else {
          this.msgToast('Update card status failed');
        }
      }, err => {
        this.msgToast('Update card status failed');
      });
    } else {
      this.nms.sendCard(cardHolderNbr).subscribe((res: any) => {
        if (res.code=="SUCCESS") {
          this.ref.close();
          setTimeout(() => {
            this.messageService.add({ severity: 'success', summary: 'Membership', detail: 'E-Card download link is successfully sent' });
        }, 1000);
          
        }
      });
    }
  }

  msgToast(msg) {
    this.messageService.add({ severity: 'error', summary: 'Generate E Card', detail: msg });
  }
  reset() {
    this.notFound = true;
  }

  printCard(cardHolderType,cardHolderNbr) {
    if(this.cardHolderInfo.status == "P") {
      this.nms.updateCardStatus(cardHolderNbr).subscribe((res: any) => {
        if (res.code=="SUCCESS") {
          if (cardHolderType == "P") {
            var node = document.getElementById('photoID');
          } else {
            var node = document.getElementById('secondaryID');
          }
          
          domtoimage.toPng(node).then(function (dataUrl) {
            var temp = document.getElementById('cardImg');
            if(temp) {
              document.body.removeChild(temp);
            }
            var image = new Image();
            image.src = dataUrl;
            image.id = "cardImg";
            image.style.display = "none";
            document.body.appendChild(image);
            setTimeout(() => {
              window.print();
            }, 500);
          })
        } else {
          this.msgToast('Update card status failed');
        }
      }, err => {
        this.msgToast('Update card status failed');
      });
    } else {
      if (cardHolderType == "P") {
        var node = document.getElementById('photoID');
      } else {
        var node = document.getElementById('secondaryID');
      }
      domtoimage.toPng(node).then(function (dataUrl) {
        var temp = document.getElementById('cardImg');
        if(temp) {
          document.body.removeChild(temp);
        }
        var image = new Image();
        image.src = dataUrl;
        image.id = "cardImg";
        image.style.display = "none";
        document.body.appendChild(image);
        setTimeout(() => {
          window.print();
        }, 500);
      })
    }
  }
}

